$(document).ready(function(){

  function change_count_number(){
    if(scrollY+$(window).height() > ($('.custom_count_section').offset().top + 200) && !$('.custom_count_section').hasClass("load_one_time")){
        $('.custom_count_section').addClass("load_one_time");
        var countItems = $('.count_item_number');
        function updateCounter(index) {
          if (index >= countItems.length) return; 
          
          var val = countItems.eq(index);
          var ctn = parseInt(val.attr("data-count"));
          var upto = 0;
          var interval = 10; 
          var step = 2; 
          
          function update() {
            upto += step;
            val.html(upto);
            if (upto >= ctn) {
              clearInterval(counts);
              updateCounter(index + 1); 
            }
          }
          
          var counts = setInterval(update, interval);
        }
        
        updateCounter(0);
      }   
  }
  
  if($('.count_item_number').length > 0){
    change_count_number();
    $(window).on("scroll",function(){
      change_count_number();
    });
  }
});